/**
 * Filtrlar manzilda saqlanadi: sahifani yangilash yoki havolani ulashish
 * bir xil ro'yxatni ochadi.
 */
export function readPage(params: URLSearchParams): number {
  const page = Number(params.get("page"));
  return Number.isInteger(page) && page > 0 ? page : 1;
}

export function readEnum<T extends string>(
  params: URLSearchParams,
  key: string,
  allowed: readonly T[],
): T | undefined {
  const value = params.get(key);
  return value && (allowed as readonly string[]).includes(value) ? (value as T) : undefined;
}

/**
 * Yangi parametrlar: bo'sh qiymat o'chiriladi, filtr o'zgarsa sahifa 1 ga
 * qaytadi (aks holda 5-sahifada qolib, bo'sh ro'yxat ko'rinadi).
 */
export function withParams(
  current: URLSearchParams,
  changes: Record<string, string | number | undefined>,
): URLSearchParams {
  const next = new URLSearchParams(current);
  for (const [key, value] of Object.entries(changes)) {
    if (value === undefined || value === "") next.delete(key);
    else next.set(key, String(value));
  }
  if (!("page" in changes)) next.delete("page");
  if (next.get("page") === "1") next.delete("page");
  return next;
}
